import { render, staticRenderFns } from "./specials-page.vue?vue&type=template&id=25c4add8&"
import script from "./specials-page.vue?vue&type=script&lang=js&"
export * from "./specials-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports